import React from 'react';
import { Link } from 'react-router-dom';

const ProductSection = () => {
    return (
        <section className="productSection">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 leftSection">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="commanHead">
                                    <h2>Why Us?</h2>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <p className="whytxt">
                                    Adber Infra India Pvt. Ltd. supplies high quality ready mixed concrete and floor screed for domestic, commercial and industrial projects. The company had started production of Ready Mix Concrete in the year 2014 and set up 2 production plant, 2 concrete pumps and 10 transit mixer in Pune. We offer top quality concrete solutions at cost-effective rates !!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="row whyicons text-center">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                {/* Commented out as it's not being used */}
                                {/* <div className="whyheadStyle">
                  <h5>We offer top quality concrete solutions at cost-effective rates !!</h5>
                </div> */}
                            </div>
                            <div className="col-md-4 col-sm-4 col-xs-12 whyoutr" data-aos="zoom-in" data-aos-delay="300" data-aos-duration="1000" data-aos-once="true">
                                <div className="iconsBox">
                                    <div className="img_div">
                                        <img src="../assets/images/icon/concrete-mixer-tool.png" alt="Concrete Mixer Tool" />
                                    </div>
                                    <ul>
                                        <li>Putzmeister Plant Capacity- 30 M<sup>3</sup>/Hr</li>
                                        <li>Sany Plant Capacity - 120 M<sup>3</sup>/Hr</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4 col-xs-12 whyoutr" data-aos="zoom-in" data-aos-delay="700" data-aos-duration="1000" data-aos-once="true">
                                <div className="iconsBox">
                                    <div className="img_div">
                                        <img src="../assets/images/icon/concrete-pump.png" alt="Concrete Pump" />
                                    </div>
                                    <ul>
                                        <li>Concrete Pumps - Putzmeister Pump - 1405 D, Aquarius Pump - 1405 D</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4 col-xs-12 whyoutr" data-aos="zoom-in" data-aos-delay="700" data-aos-duration="1000" data-aos-once="true">
                                <div className="iconsBox">
                                    <div className="img_div">
                                        <img src="../assets/images/icon/lab.png" alt="Laboratory" />
                                    </div>
                                    <ul>
                                        <li>Fleet of Transit Mixers - 21+</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                                <Link to="/why-choose-us" className="popart-btn" data-form="order-form" data-btn-type="open-form">Read More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductSection;
